export type FMTP = {
    'profile-level-id'?: string;
    'x-google-min-bitrate'?: number;
    'x-google-max-bitrate'?: number;
    'x-google-start-bitrate'?: number;
} & Record<string, string | number | undefined>;

export function parseFMTP(fmtp: string) {
    return fmtp.split(';').reduce<FMTP>((aux, item) => {
        const [key, ...value] = item.split('=');

        aux[key] = value.join('=');

        return aux;
    }, {});
}

export function modifyFMTP(fmtp: string, update: FMTP) {
    const parsed = parseFMTP(fmtp);

    for (const [key, value] of Object.entries(update)) {
        parsed[key] = value;
    }

    return Object.entries(parsed)
        .filter(([, value]) => value !== undefined && value !== null)
        .map((entry) => entry.join('='))
        .join(';');
}
